import { render } from "./role-multiselect.vue?vue&type=template&id=9ebcfc2e&scoped=true&ts=true"
import script from "./role-multiselect.vue?vue&type=script&lang=ts"
export * from "./role-multiselect.vue?vue&type=script&lang=ts"

import "./role-multiselect.vue?vue&type=style&index=0&id=9ebcfc2e&scoped=true&lang=css"

import exportComponent from "D:\\project\\unnati\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ebcfc2e"]])

export default __exports__